module.exports = __webpack_public_path__ + "static/assets/996ba2aee837bdfd7f27a4d04ef5fd7e.png";